module.exports = __webpack_public_path__ + "img/choosePayment.8f895a9b.jpg";